'use client'
import { cn } from "@/lib/utils";
import { NoSsr } from "@mui/material";
import { Flex, Text } from "@radix-ui/themes";
import { format } from "date-fns";
import { PT_Mono } from "next/font/google";
import React from "react";

interface Props {
  startDate: Date;
  endDate: Date;
  className?: string;
}
const PTMono = PT_Mono({ weight: "400", subsets: ["latin"] });
const ListDetails = ({ startDate, endDate, className }: Props) => {
  return (
    <Flex
      className={cn(PTMono.className, "w-full max-w-64", className)}
      direction={"column"}
    >
      <Flex className="" direction="column" justify={"center"} align={"center"}>
        <Text>Auction Open & Close</Text>
        <Text>{"\u00A0"}</Text>
      </Flex>
      <Flex
        justify={"between"}
        direction={"row"}
        className="gap-8"
      >
        <Text>Open</Text>
        <NoSsr>
          <Text>{format(startDate, "EEE MMM d yyyy")}</Text>
        </NoSsr>
      </Flex>
      <Flex
        justify={"between"}
        direction={"row"}
        className="gap-8"
      >
        <Text>Close</Text>
        <NoSsr>
          <Text>{format(endDate, "EEE MMM d yyyy")}</Text>
        </NoSsr>
      </Flex>
    </Flex>
  );
};
export default ListDetails;
